(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[64720,61971,40659,81066,75847,44709,92870,98162],{

/***/ 34190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Media; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Media/utils/helpers.js
var videoFormats = function(format) {
    return [
        "video/mp4",
        "video/webm", 
    ].includes(format);
};

;// CONCATENATED MODULE: ./UI/components/Media/utils/useMediaProps.js







/* harmony default export */ function useMediaProps(_param) {
    var asset = _param.asset, className = _param.className, isStatic = _param.isStatic, transparent = _param.transparent, loaderParams = _param.loaderParams, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "asset",
        "className",
        "isStatic",
        "transparent",
        "loaderParams"
    ]);
    var ref = (0,react.useRef)(null);
    var ref1 = get_default()(asset, "fields", {}), contentType = ref1.file.contentType;
    var isVideo = videoFormats(contentType);
    var ref2 = (0,helper/* getImage */.gJ)(asset), url = ref2.url, alt = ref2.alt;
    var imageProps = (0,_object_spread/* default */.Z)({
        alt: alt,
        src: url,
        layout: "fill",
        lazyBoundary: "700px",
        unoptimized: true,
        loader: isStatic ? function(param) {
            var src = param.src;
            return src;
        } : function(args) {
            return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
                transparent: transparent
            }, args, loaderParams));
        }
    }, rest);
    return (0,_object_spread/* default */.Z)({
        ref: ref,
        url: url,
        isVideo: isVideo,
        className: className,
        imageProps: imageProps
    }, rest);
};

// EXTERNAL MODULE: ./UI/components/Media/styles.module.scss
var styles_module = __webpack_require__(6992);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Media/index.jsx










var Media = function(_param) {
    var renderVideoPlayer = _param.renderVideoPlayer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "renderVideoPlayer"
    ]);
    var _ref = useMediaProps(props), ref = _ref.ref, url = _ref.url, isVideo = _ref.isVideo, className = _ref.className, imageProps = _ref.imageProps, playControl = _ref.playControl, posterUrl = _ref.posterUrl, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref",
        "url",
        "isVideo",
        "className",
        "imageProps",
        "playControl",
        "posterUrl"
    ]);
    if (isVideo) {
        if (renderVideoPlayer) {
            return renderVideoPlayer({
                src: url,
                description: imageProps.alt
            });
        }
        if (playControl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["video-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref,
                    controls: true,
                    poster: posterUrl,
                    className: className
                }, rest), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/mp4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/webm"
                        })
                    ]
                }))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            muted: true,
            autoPlay: true,
            loop: true,
            playsInline: true,
            className: className
        }, rest), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/webm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/mp4"
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()((styles_module_default()).image, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, imageProps))
    });
};
Media.propTypes = {
    asset: prop_types_default().instanceOf(Object).isRequired,
    autoPlay: (prop_types_default()).bool,
    loop: (prop_types_default()).bool,
    playsInline: (prop_types_default()).bool,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    renderVideoPlayer: (prop_types_default()).func
};
/* harmony default export */ var components_Media = (Media);


/***/ }),

/***/ 61971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);
/* eslint-disable react/destructuring-assignment */ 




var ScrollAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 71317).then(__webpack_require__.t.bind(__webpack_require__, 71317, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71317)
            ];
        }
    }
});
var Reveal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 8365).then(__webpack_require__.t.bind(__webpack_require__, 8365, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8365)
            ];
        }
    }
});
var Fade = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19470).then(__webpack_require__.t.bind(__webpack_require__, 19470, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19470)
            ];
        }
    }
});
var CSSAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 90959).then(__webpack_require__.bind(__webpack_require__, 90959)).then(function(module) {
        return module.CSSAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90959)
            ];
        }
    }
});
var ImageZoom = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 16626).then(__webpack_require__.bind(__webpack_require__, 16626));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16626)
            ];
        }
    }
});
var Gsap = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94744).then(__webpack_require__.bind(__webpack_require__, 94744)).then(function(module) {
        return module.Gsap;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94744)
            ];
        }
    }
});
var ParallaxWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(11897)]).then(__webpack_require__.bind(__webpack_require__, 11897));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11897)
            ];
        }
    }
});
var ExpandWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68376).then(__webpack_require__.bind(__webpack_require__, 68376)).then(function(module) {
        return module.ExpandWrapper;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68376)
            ];
        }
    }
});
var CustomAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52612).then(__webpack_require__.bind(__webpack_require__, 52612)).then(function(module) {
        return module.CustomAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52612)
            ];
        }
    }
});
var JSONAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(51028), __webpack_require__.e(69255), __webpack_require__.e(25845)]).then(__webpack_require__.bind(__webpack_require__, 25845)).then(function(module) {
        return module.JSONAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25845)
            ];
        }
    }
});
var Bounce = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94803).then(__webpack_require__.t.bind(__webpack_require__, 94803, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94803)
            ];
        }
    }
});
var CounterAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(78162)]).then(__webpack_require__.bind(__webpack_require__, 78162));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78162)
            ];
        }
    }
});
var ZoomOut = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(30730)]).then(__webpack_require__.bind(__webpack_require__, 30730));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30730)
            ];
        }
    }
});
var Animated = function(props) {
    switch(props.type){
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isReveal */ .BK.isReveal:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Reveal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isFade */ .BK.isFade:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fade, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCustom */ .BK.isCustom:
            {
                if (Object.keys(props).length === 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isJSON */ .BK.isJSON:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(JSONAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isParallaxSpring */ .BK.isParallaxSpring:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParallaxWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageZoom, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.gsap */ .BK.gsap:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Gsap, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.expandByHeight */ .BK.expandByHeight:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpandWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCSS */ .BK.isCSS:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CSSAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.bounce */ .BK.bounce:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Bounce, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    })
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.counter */ .BK.counter:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CounterAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.zoomOut */ .BK.zoomOut:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ZoomOut, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Animated);


/***/ }),

/***/ 4557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_ProjectIdea; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./components/CaseStudiesCommon/utils/data.js
var utils_data = __webpack_require__(27515);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/KeyFeatures/utils/useKeyFeatures.js


var useKeyFeatures = function(param) {
    var features = param.features, type = param.type;
    var ref;
    var containerBackgroundImage = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(features, "images[0]", {})), {
        fm: "png"
    });
    var containerStyle = containerBackgroundImage ? {
        backgroundImage: "url(".concat(containerBackgroundImage, ")")
    } : {};
    var isEmptyContentModules = !get_default()(features, "contentModules");
    var content = (ref = features.contentModules) === null || ref === void 0 ? void 0 : ref.map(function(data) {
        var ref = (0,helper/* getDocumentFields */.OA)(data), title = ref.title, text = ref.text, contentList = ref.contentList;
        var icon = contentList === null || contentList === void 0 ? void 0 : contentList[0];
        return {
            title: title,
            text: text,
            icon: icon
        };
    });
    return {
        type: type,
        content: content,
        containerStyle: containerStyle,
        isEmptyContentModules: isEmptyContentModules,
        icon: containerBackgroundImage
    };
};

// EXTERNAL MODULE: ./UI/components/KeyFeatures/styles.module.scss
var styles_module = __webpack_require__(85417);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/KeyFeatures/index.jsx












var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var Animated = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var KeyFeatures = function(props) {
    var ref = useKeyFeatures(props), type = ref.type, content = ref.content, containerStyle = ref.containerStyle, isEmptyContentModules = ref.isEmptyContentModules;
    if (isEmptyContentModules) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils_data/* ANIMATION_CASE_STUDY_PROPS */.e), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((styles_module_default())[type], (styles_module_default()).container),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).containerBackground,
                    style: containerStyle
                }),
                content === null || content === void 0 ? void 0 : content.map(function(param, index) {
                    var title = param.title, text = param.text, icon = param.icon;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        delay: 50 * index
                    }, utils_data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((styles_module_default()).featureContainer, (styles_module_default())["featureContainer-".concat(index + 1)]),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).checkMark,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                        className: (styles_module_default()).icon,
                                        type: icon !== null && icon !== void 0 ? icon : constants/* SVG_IMAGES_TYPES.check */.NL.check
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).contentContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                            variant: "h2",
                                            className: (styles_module_default()).title,
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                            document: text
                                        })
                                    ]
                                })
                            ]
                        })
                    }), title);
                })
            ]
        })
    }));
};
KeyFeatures.propTypes = {
    type: (prop_types_default()).string,
    features: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var components_KeyFeatures = (KeyFeatures);

// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
;// CONCATENATED MODULE: ./UI/components/TeamList/utils/useTeamSection.js


var useTeamSection = function(param) {
    var type = param.type, data = param.data;
    var title = data.title, contentList = data.contentList, contentModules = data.contentModules, imagesBundles = data.imagesBundles;
    var specialTeamList = contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(module) {
        var ref = (0,helper/* getDocumentFields */.OA)(module, [
            "contentList",
            "title"
        ]), list = ref.contentList, listTitle = ref.title;
        return {
            list: list,
            listTitle: listTitle
        };
    });
    var images = (imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(image) {
        return (0,helper/* getFileUrl */.qm)(image);
    })) || [];
    var backgroundImageUrl = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(data, "images[0]", "")), {
        fm: "webp"
    });
    var style = backgroundImageUrl ? {
        backgroundImage: "url(".concat(backgroundImageUrl, ")")
    } : {};
    return {
        type: type,
        style: style,
        title: title,
        contentList: contentList,
        specialTeamList: specialTeamList,
        images: images
    };
};

// EXTERNAL MODULE: ./UI/components/TeamList/styles.module.scss
var TeamList_styles_module = __webpack_require__(62674);
var TeamList_styles_module_default = /*#__PURE__*/__webpack_require__.n(TeamList_styles_module);
;// CONCATENATED MODULE: ./UI/components/TeamList/index.jsx











var TeamList_Animated = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var TeamList = function(props) {
    var ref = useTeamSection(props), type = ref.type, style = ref.style, title = ref.title, images = ref.images, contentList = ref.contentList, specialTeamList = ref.specialTeamList;
    if (!title && !contentList && !specialTeamList && !(images === null || images === void 0 ? void 0 : images.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamList_Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils_data/* ANIMATION_CASE_STUDY_PROPS */.e), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: style,
            className: classnames_default()((TeamList_styles_module_default())[type], (TeamList_styles_module_default()).container),
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    variant: "h2",
                    className: (TeamList_styles_module_default()).title,
                    children: title
                }),
                contentList === null || contentList === void 0 ? void 0 : contentList.map(function(member) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        variant: "p",
                        className: (TeamList_styles_module_default()).teamItem,
                        children: member
                    }, member);
                }),
                specialTeamList === null || specialTeamList === void 0 ? void 0 : specialTeamList.map(function(param, index) {
                    var list = param.list, listTitle = param.listTitle;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TeamList_styles_module_default()).teamList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                variant: "p",
                                className: classnames_default()((TeamList_styles_module_default()).listTitle, (TeamList_styles_module_default())["listTitle-".concat(index + 1)]),
                                children: listTitle
                            }),
                            list.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                    variant: "p",
                                    className: (TeamList_styles_module_default()).listItem,
                                    children: item
                                }, item);
                            })
                        ]
                    }, listTitle);
                }),
                images.map(function(imgUrl, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        transparent: true,
                        className: classnames_default()((TeamList_styles_module_default()).bundleImage, (TeamList_styles_module_default())["bundleImage-".concat(index + 1)]),
                        src: imgUrl,
                        alt: title
                    }, "intro-images-bundles/".concat(imgUrl));
                })
            ]
        })
    }));
};
TeamList.propTypes = {
    type: (prop_types_default()).string.isRequired,
    data: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var components_TeamList = (TeamList);

// EXTERNAL MODULE: ./UI/components/ CaseAdditionalContent/styles.module.scss
var _CaseAdditionalContent_styles_module = __webpack_require__(88509);
var _CaseAdditionalContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(_CaseAdditionalContent_styles_module);
;// CONCATENATED MODULE: ./UI/components/ CaseAdditionalContent/index.jsx





var CaseAdditionalContent = function(param) {
    var type = param.type, data = param.data, view = param.view;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((_CaseAdditionalContent_styles_module_default()).additionalContent, (_CaseAdditionalContent_styles_module_default())[type], (_CaseAdditionalContent_styles_module_default())[view]),
        children: data === null || data === void 0 ? void 0 : data.map(function(param, index) {
            var title = param.title, description = param.description, contentList = param.contentList, text = param.text;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((_CaseAdditionalContent_styles_module_default()).container, (_CaseAdditionalContent_styles_module_default())["container-".concat(index + 1)]),
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (_CaseAdditionalContent_styles_module_default()).title,
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (_CaseAdditionalContent_styles_module_default()).description,
                        children: description
                    }),
                    (contentList === null || contentList === void 0 ? void 0 : contentList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (_CaseAdditionalContent_styles_module_default()).listContainer,
                        children: contentList === null || contentList === void 0 ? void 0 : contentList.map(function(info) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (_CaseAdditionalContent_styles_module_default()).listItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: info
                                })
                            }, info);
                        })
                    }),
                    text && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                        document: text
                    })
                ]
            }, title);
        })
    });
};
CaseAdditionalContent.defaultProps = {
    data: null
};
CaseAdditionalContent.propTypes = {
    type: (prop_types_default()).string.isRequired,
    data: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var _CaseAdditionalContent = (CaseAdditionalContent);

// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx + 1 modules
var SectionTitle = __webpack_require__(36837);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./UI/containers/Animated/index.jsx
var containers_Animated = __webpack_require__(61971);
// EXTERNAL MODULE: ./UI/components/CaseImageContent/styles.module.scss
var CaseImageContent_styles_module = __webpack_require__(32015);
var CaseImageContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(CaseImageContent_styles_module);
;// CONCATENATED MODULE: ./UI/components/CaseImageContent/index.jsx











var CaseImageContent = function(param) {
    var image = param.image, textContent = param.textContent, type = param.type, view = param.view;
    return (image.url || textContent) && /*#__PURE__*/ (0,jsx_runtime.jsx)(containers_Animated["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils_data/* ANIMATION_CASE_STUDY_PROPS */.e), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((CaseImageContent_styles_module_default()).blockContainer, (CaseImageContent_styles_module_default())[type], (CaseImageContent_styles_module_default())[view]),
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    className: (CaseImageContent_styles_module_default()).image,
                    src: image.url,
                    alt: image.alt
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CaseImageContent_styles_module_default()).container,
                    children: textContent === null || textContent === void 0 ? void 0 : textContent.map(function(param, index) {
                        var title = param.title, description = param.description, contentList = param.contentList;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((CaseImageContent_styles_module_default()).textContainer, (CaseImageContent_styles_module_default())["textContainer-".concat(index + 1)]),
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                    variant: "p",
                                    className: (CaseImageContent_styles_module_default()).title,
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                    variant: "p",
                                    className: (CaseImageContent_styles_module_default()).description,
                                    children: description
                                }),
                                (contentList === null || contentList === void 0 ? void 0 : contentList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (CaseImageContent_styles_module_default()).listContainer,
                                    children: contentList === null || contentList === void 0 ? void 0 : contentList.map(function(info) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: (CaseImageContent_styles_module_default()).listItem,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: info
                                            })
                                        }, info);
                                    })
                                })
                            ]
                        }, title);
                    })
                })
            ]
        })
    }));
};
CaseImageContent.propTypes = {
    type: (prop_types_default()).string,
    textContent: prop_types_default().instanceOf(Object),
    image: (prop_types_default()).string
};
/* harmony default export */ var components_CaseImageContent = (CaseImageContent);

// EXTERNAL MODULE: ./UI/components/Media/index.jsx + 2 modules
var Media = __webpack_require__(34190);
;// CONCATENATED MODULE: ./UI/sections/ProjectIdea/utils/useProjectIdea.js





var useProjectIdea = function(param) {
    var type = param.type, data = param.data;
    var ref, ref1, ref2;
    var sectionTitle = data.title, sectionSubtitle = data.subtitle, sectionDescription = data.description, view = data.view, background = data.background, images = data.images;
    var ref3 = (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[1]", {}), [
        "title",
        "subtitle",
        "text",
        "contentModules", 
    ]), title = ref3.title, subtitle = ref3.subtitle, text = ref3.text, contentModules = ref3.contentModules;
    var delayedAnimation = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils_data/* ANIMATION_CASE_STUDY_PROPS */.e), {
        delay: 50
    });
    var featuresProps = (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[0]", {}), [
        "contentModules"
    ]);
    var teamListProps = (data === null || data === void 0 ? void 0 : (ref = data.contentModules) === null || ref === void 0 ? void 0 : ref[2]) && (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[2]", {}), [
        "title",
        "contentModules",
        "contentList",
        "imagesBundles", 
    ]);
    var imageContent = (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[3]", {}), [
        "contentModules",
        "images"
    ]);
    var additionalContent = contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(con) {
        return (0,helper/* getDocumentFields */.OA)(con, [
            "title",
            "contentList",
            "description",
            "text", 
        ]);
    });
    var textContent = imageContent === null || imageContent === void 0 ? void 0 : (ref1 = imageContent.contentModules) === null || ref1 === void 0 ? void 0 : ref1.map(function(con) {
        return (0,helper/* getDocumentFields */.OA)(con, [
            "title",
            "contentList",
            "description"
        ]);
    });
    var image = (0,helper/* getImage */.gJ)(imageContent === null || imageContent === void 0 ? void 0 : (ref2 = imageContent.images) === null || ref2 === void 0 ? void 0 : ref2[0]);
    return {
        type: type,
        sectionTitle: sectionTitle,
        sectionDescription: sectionDescription,
        sectionSubtitle: sectionSubtitle,
        title: title,
        subtitle: subtitle,
        text: text,
        additionalContent: additionalContent,
        delayedAnimation: delayedAnimation,
        featuresProps: featuresProps,
        teamListProps: teamListProps,
        image: image,
        textContent: textContent,
        view: view,
        background: (0,helper/* getImage */.gJ)(background),
        images: images
    };
};

// EXTERNAL MODULE: ./UI/sections/ProjectIdea/styles.module.scss
var ProjectIdea_styles_module = __webpack_require__(55286);
var ProjectIdea_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProjectIdea_styles_module);
;// CONCATENATED MODULE: ./UI/sections/ProjectIdea/index.jsx


















var ProjectIdea_Animated = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var ProjectIdea = function(props) {
    var ref = useProjectIdea(props), type = ref.type, view = ref.view, title = ref.title, sectionTitle = ref.sectionTitle, sectionDescription = ref.sectionDescription, sectionSubtitle = ref.sectionSubtitle, subtitle = ref.subtitle, text = ref.text, additionalContent = ref.additionalContent, image = ref.image, delayedAnimation = ref.delayedAnimation, featuresProps = ref.featuresProps, teamListProps = ref.teamListProps, textContent = ref.textContent, background = ref.background, images = ref.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((ProjectIdea_styles_module_default())[type], (ProjectIdea_styles_module_default()).container, (ProjectIdea_styles_module_default())[view]),
        children: [
            background && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                src: background.url,
                alt: "",
                className: (ProjectIdea_styles_module_default()).background
            }),
            sectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: sectionTitle,
                subtitle: sectionSubtitle,
                description: sectionDescription,
                className: (ProjectIdea_styles_module_default()).titleStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProjectIdea_styles_module_default()).contentContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_KeyFeatures, {
                        features: featuresProps,
                        type: type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaseImageContent, {
                        type: type,
                        image: image,
                        textContent: textContent,
                        view: view
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProjectIdea_styles_module_default()).descriptionContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProjectIdea_styles_module_default()).descriptionIntro,
                                children: [
                                    (title || subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectIdea_Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils_data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                                className: (ProjectIdea_styles_module_default()).sectionName,
                                                children: subtitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                                variant: "h2",
                                                className: (ProjectIdea_styles_module_default()).title,
                                                children: title
                                            })
                                        ]
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectIdea_Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, delayedAnimation), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ProjectIdea_styles_module_default()).description,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                                document: text
                                            })
                                        })
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectIdea_Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, delayedAnimation), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_CaseAdditionalContent, {
                                    data: additionalContent,
                                    type: type,
                                    view: view
                                })
                            }))
                        ]
                    }),
                    images === null || images === void 0 ? void 0 : images.map(function(file, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                            asset: file,
                            className: classnames_default()((ProjectIdea_styles_module_default()).media, (ProjectIdea_styles_module_default())["media-".concat(index + 1)])
                        }, "media=".concat(index + 1));
                    })
                ]
            }),
            teamListProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TeamList, {
                data: teamListProps,
                type: type
            })
        ]
    });
};
ProjectIdea.defaultProps = {
    type: "",
    isMobileResolution: false
};
ProjectIdea.propTypes = {
    type: (prop_types_default()).string,
    data: prop_types_default().instanceOf(Object).isRequired,
    isMobileResolution: (prop_types_default()).bool
};
/* harmony default export */ var sections_ProjectIdea = (ProjectIdea);


/***/ }),

/***/ 92870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74129);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40659);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96076);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var UI_components_Media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34190);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69123);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);













var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var GalleryCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 34378).then(__webpack_require__.bind(__webpack_require__, 34378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34378)
            ];
        }
    }
});
var ArticleLink = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7002).then(__webpack_require__.bind(__webpack_require__, 7002)).then(function(module) {
        return module.ArticleLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7002)
            ];
        }
    }
});
var Table = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 84059).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var EmbedArticleCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 80931).then(__webpack_require__.bind(__webpack_require__, 80931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80931)
            ];
        }
    }
});
var Illustration = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 93812).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
// TODO move it to the common folder
// TODO create constants for cases
var ContentfulParser = function(param) {
    var document = param.document, linkIcon = param.linkIcon;
    var _obj, _obj1;
    var options = {
        renderMark: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.CODE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sub", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.BOLD, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.ITALIC, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.UNDERLINE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                children: node
            });
        }), _obj),
        renderNode: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var id = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target.sys.contentType.sys.id", "");
            switch(id){
                case "image":
                    {
                        var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", ""), [
                            "articleSingleImageType",
                            "image",
                            "title"
                        ]), articleSingleImageType = ref.articleSingleImageType, rawImage = ref.image, title = ref.title;
                        var image = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getImage */ .gJ)(rawImage);
                        var _obj;
                        return articleSingleImageType && image.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imageWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().normalImage), articleSingleImageType === "normal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fullImage), articleSingleImageType !== "normal"), _obj)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, {
                                        type: utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Illustration, {
                                            src: image.url,
                                            alt: image.alt,
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                                        })
                                    }),
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().photoCaption),
                                        children: title
                                    })
                                ]
                            })
                        });
                    }
                case "articleGalleryCard":
                    {
                        var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "images",
                            "photoCaption"
                        ]), images = ref1.images, photoCaption = ref1.photoCaption;
                        return images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryCard, {
                            images: images,
                            photoCaption: photoCaption
                        });
                    }
                case "link":
                    {
                        var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref2 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data, [
                            "title",
                            "buttonTitle",
                            "slug",
                            "type",
                            "url",
                            "new", 
                        ]), title1 = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug, type = ref2.type, url = ref2.url, isNew = ref2.new;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleLink, {
                            data: data,
                            new: isNew,
                            title: title1,
                            buttonTitle: buttonTitle,
                            slug: slug,
                            type: type,
                            url: url,
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().videoSection)
                        });
                    }
                case "table":
                    {
                        var ref3 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "tableContent",
                            "tableType"
                        ]), tableContent = ref3.tableContent, tableType = ref3.tableType;
                        return tableContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Table, {
                            tableData: tableContent.tableData,
                            type: tableType
                        });
                    }
                case "article":
                    {
                        var data1 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedArticleCard, {
                            data: data1
                        });
                    }
                case "text":
                    {
                        var data2 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref4 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data2, [
                            "text",
                            "id"
                        ]), text = ref4.text, entryId = ref4.id;
                        return(// eslint-disable-next-line react/no-unknown-property
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "grid-area": entryId,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulParser, {
                                document: text
                            })
                        }));
                    }
                default:
                    return null;
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
            return(// eslint-disable-next-line react/no-unknown-property
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "grid-area": "asset",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Media__WEBPACK_IMPORTED_MODULE_10__["default"], {
                    asset: data
                })
            }));
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().quote),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h3),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ul),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                type: "1",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ol),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
            var uri = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.uri", "/");
            var isInternalLink = uri.includes(utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .rootUrl */ .Wd);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                path: uri,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().a),
                isLocalLink: isInternalLink,
                children: [
                    children,
                    linkIcon
                ]
            });
        }), _obj1)
    };
    return document ? (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .documentToReactComponents */ .h)(document, options) : "";
};
ContentfulParser.defaultProps = {
    document: null
};
ContentfulParser.propTypes = {
    document: prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["default"] = (ContentfulParser);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 88509:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additionalContent":"styles_additionalContent__BW3_Z","container":"styles_container__bNBak","title":"styles_title__l6zZD","listContainer":"styles_listContainer__5GWsY","listItem":"styles_listItem__hsaSj","seven-pm-thursday":"styles_seven-pm-thursday__XAI0I","fernwayer":"styles_fernwayer__LvT_b","drive-focus":"styles_drive-focus__JuVqG","famlicious":"styles_famlicious___qFLZ","natp":"styles_natp__FbnVy","writer-chrome-extension":"styles_writer-chrome-extension__FRvwu","ubichat":"styles_ubichat__F1ynb","meateater":"styles_meateater__b18c6","bionorica":"styles_bionorica__2wk3Y","fusion-markets":"styles_fusion-markets__M7So2","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__D7ijc","beautonomy":"styles_beautonomy__Ei6Gy","smartcenter":"styles_smartcenter__KOqlL","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__eZe02","dindon":"styles_dindon___ACHW","humankind":"styles_humankind__X0bIw","container-1":"styles_container-1__D3tJ3","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__AYFAP","mobile-bank-application":"styles_mobile-bank-application__42Uey","software-for-mri-interpretation":"styles_software-for-mri-interpretation__7g0D4","container-2":"styles_container-2__a8cwE","container-3":"styles_container-3__n11_s","cedar-valley-farms":"styles_cedar-valley-farms__Sy48U","description":"styles_description__3D4Xq","mobile-budgeting-app":"styles_mobile-budgeting-app__zolct","forex-trading-platform":"styles_forex-trading-platform__cZTzE","crowdfunding-platform":"styles_crowdfunding-platform__XDRnz","firstSectionView":"styles_firstSectionView__az7UV","secondSectionView":"styles_secondSectionView__lKosG","web-chat-for-mediums":"styles_web-chat-for-mediums__CLC88","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer___Sm7w","mobile-music-app":"styles_mobile-music-app__35FyI","clairvoyant-directory-upgrade":"styles_clairvoyant-directory-upgrade__EAVKC","thirdSectionView":"styles_thirdSectionView__87RjF","descriptionIntro":"styles_descriptionIntro__UfEBB","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__F596f","restaurant-asset-management-tool":"styles_restaurant-asset-management-tool__v35g5","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__FA_EZ","ai-based-travel-planner":"styles_ai-based-travel-planner__XL5lI","ai-streamlined-recruitment-process":"styles_ai-streamlined-recruitment-process__CkyqJ","writer-framework-platform":"styles_writer-framework-platform__1QDJV","enhancing-money-laundering-mention-extraction":"styles_enhancing-money-laundering-mention-extraction__SmG2x"};

/***/ }),

/***/ 32015:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cedar-valley-farms":"styles_cedar-valley-farms__zIL2z","image":"styles_image__lBSBi","container":"styles_container__pgB9H","textContainer":"styles_textContainer__nGEa4","title":"styles_title__KJvmS","description":"styles_description__X41iP","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__mSYCk","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__Uu0AE","secondSectionView":"styles_secondSectionView__iMmS6","restaurant-asset-management-tool":"styles_restaurant-asset-management-tool__phAeO","custom-payment-gateway":"styles_custom-payment-gateway__gbx4s"};

/***/ }),

/***/ 85417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__FdyW3","containerBackground":"styles_containerBackground__uFnLm","featureContainer":"styles_featureContainer__QoLd6","checkMark":"styles_checkMark__a9jva","icon":"styles_icon__NUVs0","contentContainer":"styles_contentContainer__TicuD","title":"styles_title__5LPNv","stickerbox":"styles_stickerbox__Yk2IV","fireaway":"styles_fireaway__TztJ1","fairy":"styles_fairy__ojA_R","seven-pm-thursday":"styles_seven-pm-thursday__zhPNv","fernwayer":"styles_fernwayer__U5gVU","drive-focus":"styles_drive-focus__rRikf","hotel-data-cloud":"styles_hotel-data-cloud__tiHDb","open-sense":"styles_open-sense__Jokqs","separate-us":"styles_separate-us__q92_a","famlicious":"styles_famlicious__rqzR4","natp":"styles_natp__QkWgC","travel-trivia":"styles_travel-trivia__8quyt","cash-chat":"styles_cash-chat__mk2ha","tell":"styles_tell__NId4h","ubichat":"styles_ubichat__Hs9Zw","writer-chrome-extension":"styles_writer-chrome-extension__cvRaD","featureContainer-2":"styles_featureContainer-2__uIYEI","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__Kn1Mx","beautonomy":"styles_beautonomy__L1mrB","telemojo":"styles_telemojo__6aTlc","blackbird":"styles_blackbird__47v_l","smartcenter":"styles_smartcenter__Az2gk","cinnabar":"styles_cinnabar__L07oe","mobile-bank-application":"styles_mobile-bank-application__FzMV4","software-for-mri-interpretation":"styles_software-for-mri-interpretation__aWyDB","mobile-budgeting-app":"styles_mobile-budgeting-app__cHJEw","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__Xt2oD","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__YTJku","ai-documentation-processing":"styles_ai-documentation-processing__vfl2w","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__Komfj","featureContainer-1":"styles_featureContainer-1__vToJZ","featureContainer-3":"styles_featureContainer-3__y3pdB","featureContainer-4":"styles_featureContainer-4__oireg","computer-vision-for-aras":"styles_computer-vision-for-aras__WdFTF"};

/***/ }),

/***/ 6992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__NnBr_","video-container":"styles_video-container__3YIN0","play-button":"styles_play-button__ubn_b"};

/***/ }),

/***/ 62674:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QTnGy","travel-trivia":"styles_travel-trivia__CbgPX","title":"styles_title__M5qLW","teamItem":"styles_teamItem__N3fWc","stickerbox":"styles_stickerbox___U0yg","fairy":"styles_fairy__US_TQ","seven-pm-thursday":"styles_seven-pm-thursday__kRbdo","fernwayer":"styles_fernwayer__172kQ","drive-focus":"styles_drive-focus__QAtuT","fireaway":"styles_fireaway__qI5Ik","hotel-data-cloud":"styles_hotel-data-cloud__ozwa2","open-sense":"styles_open-sense__pLwKf","famlicious":"styles_famlicious__f36Fq","cash-chat":"styles_cash-chat__pe7Rt","tell":"styles_tell__1Mder","bundleImage-1":"styles_bundleImage-1__IWzUD","writer-chrome-extension":"styles_writer-chrome-extension__lh6KD","teamList":"styles_teamList__kqrzD","listTitle":"styles_listTitle__J9pQt","listItem":"styles_listItem__9G_tx","bundleImage":"styles_bundleImage__NbVIi","meateater":"styles_meateater__ouZ71","bionorica":"styles_bionorica__T29sz","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__aeNhX","fusion-markets":"styles_fusion-markets__NNY6F","beautonomy":"styles_beautonomy__3h1ym","telemojo":"styles_telemojo__lK_Bw","blackbird":"styles_blackbird__ydPlO","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__PE4Zg","smartcenter":"styles_smartcenter__vKX7Z","dindon":"styles_dindon__AGNQB","humankind":"styles_humankind__pagwV","cinnabar":"styles_cinnabar__UsCyc","mobile-bank-application":"styles_mobile-bank-application__Qgqc7","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__P5bCe","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__O3UpO","ai-streamlined-recruitment-process":"styles_ai-streamlined-recruitment-process__JCXIL","writer-framework-platform":"styles_writer-framework-platform__d_DLN"};

/***/ }),

/***/ 55286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__tO3mL","drive-focus":"styles_drive-focus__PrXKG","mobileAdditionalInformation":"styles_mobileAdditionalInformation__OubOz","contentContainer":"styles_contentContainer__tViQH","descriptionContainer":"styles_descriptionContainer__RGxaN","sectionName":"styles_sectionName___1kMF","title":"styles_title__bHiZ5","descriptionIntro":"styles_descriptionIntro__pdlFo","description":"styles_description__wH76a","additionalInfoContainer":"styles_additionalInfoContainer__UKTho","background":"styles_background__Y6MxN","stickerbox":"styles_stickerbox__YwGO9","fireaway":"styles_fireaway__0Ta_a","fairy":"styles_fairy__mpomW","seven-pm-thursday":"styles_seven-pm-thursday__uKZnk","fernwayer":"styles_fernwayer__y76l5","containerBackground":"styles_containerBackground__PHhZ9","hotel-data-cloud":"styles_hotel-data-cloud__dDwif","open-sense":"styles_open-sense__G4GyR","separate-us":"styles_separate-us__b_VJo","natp":"styles_natp__BkKN2","travel-trivia":"styles_travel-trivia__9Ed4Y","cash-chat":"styles_cash-chat__Rdp25","ubichat":"styles_ubichat__cvd0Q","writer-chrome-extension":"styles_writer-chrome-extension__7MsbU","meateater":"styles_meateater__v6H3a","bionorica":"styles_bionorica__isI6E","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__I1fTZ","fusion-markets":"styles_fusion-markets__A3tYd","beautonomy":"styles_beautonomy__pRnxp","telemojo":"styles_telemojo__htupt","blackbird":"styles_blackbird__CWFWc","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__tNcKd","smartcenter":"styles_smartcenter__tm3rD","dindon":"styles_dindon__bnD4w","humankind":"styles_humankind__Ztpta","cinnabar":"styles_cinnabar__H5_jx","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__wRito","mobile-bank-application":"styles_mobile-bank-application__gsc_5","software-for-mri-interpretation":"styles_software-for-mri-interpretation__NnGri","cedar-valley-farms":"styles_cedar-valley-farms__n_Dc3","titleStyle":"styles_titleStyle__Mtb__","mobile-budgeting-app":"styles_mobile-budgeting-app__Y19U5","forex-trading-platform":"styles_forex-trading-platform__bh_g_","crowdfunding-platform":"styles_crowdfunding-platform__vIkzq","firstSectionView":"styles_firstSectionView__K2IR_","secondSectionView":"styles_secondSectionView__NggPs","listItem":"styles_listItem__6orNu","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__wZ6Us","web-chat-for-mediums":"styles_web-chat-for-mediums__9LHKO","web-p2p-lending-platform":"styles_web-p2p-lending-platform__ZDgur","thirdSectionView":"styles_thirdSectionView__qbHCE","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__XAt6c","mobile-music-app":"styles_mobile-music-app___PaIF","clairvoyant-directory-upgrade":"styles_clairvoyant-directory-upgrade__qdDAM","media":"styles_media__TT7Gy","fourthSectionView":"styles_fourthSectionView__ase32","media-1":"styles_media-1__lWk_l","media-2":"styles_media-2__l_Cgl","digital-wallet-for-ios":"styles_digital-wallet-for-ios__X2lxv","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__SnGWO","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__EL2qM","restaurant-asset-management-tool":"styles_restaurant-asset-management-tool__kvnl4","custom-payment-gateway":"styles_custom-payment-gateway__VsurR","ai-documentation-processing":"styles_ai-documentation-processing__8fTmt","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__9AshN","ai-based-travel-planner":"styles_ai-based-travel-planner__B3T8C","ai-streamlined-recruitment-process":"styles_ai-streamlined-recruitment-process__SBmX9","writer-framework-platform":"styles_writer-framework-platform__9NkfJ","computer-vision-for-aras":"styles_computer-vision-for-aras__7HSAp","enhancing-money-laundering-mention-extraction":"styles_enhancing-money-laundering-mention-extraction__ICKZ5"};

/***/ }),

/***/ 69123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__BMuQY","h3":"styles_h3__wh4p0","paragraph":"styles_paragraph__9NG9P","a":"styles_a__QRxdK","ul":"styles_ul__esYyW","ol":"styles_ol__ue_m_","quote":"styles_quote___48vb","imageWrapper":"styles_imageWrapper__qFsnC","fullImage":"styles_fullImage__qANu4","normalImage":"styles_normalImage__eNnG6","image":"styles_image__Lejqj","photoCaption":"styles_photoCaption__WUS8x","videoSection":"styles_videoSection__g6E1A"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);